import { ICertificateDetailResponse } from "@/entities/Certificates";
import { AppButton } from "@/shared/ui/AppButton";
import DownloadIcon from "@/shared/assets/icons/download.svg";
import { formatMinutesToHoursAndMinutes } from "@/shared/lib/utils/formatTime";
import { getColorClass } from "@/shared/lib/utils/getColorClass";
import { AnalyticsRow } from "./AnalyticsRow";

interface CourseAnalyticsProps {
  data: ICertificateDetailResponse;
}

export const CourseAnalytics = ({ data }: CourseAnalyticsProps) => {
  const { totalLessons, totalDuration, formativeCompletionPercent, averageAttendance, certificate } = data;

  const handleDownload = async () => {
    const url = certificate.pdfFile?.url;
    const filename = certificate.pdfFile?.name || `certificate-${certificate.certificateNumber}.pdf`;
    if (!url) return;
    const res = await fetch(url, { mode: 'cors' });
    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(blobUrl);
  };


  return (
    <section className="min-w-[280px] w-full max-w-[320px] flex flex-col p-4 rounded-[16px] bg-[#F9FAFB] h-fit">


      <div className="flex flex-col gap-y-[10px]">
        <AnalyticsRow title="Analytics of the course" isHeader />
        <AnalyticsRow title="Activities" value={totalLessons} valueColor="black" />
        <AnalyticsRow title="Total length" value={formatMinutesToHoursAndMinutes(totalDuration)} valueColor="black" />
        <AnalyticsRow title="Completing homework" value={`${formativeCompletionPercent}%`} valueColor={getColorClass(formativeCompletionPercent)} />
        <AnalyticsRow title="Attendance" value={`${averageAttendance}%`} valueColor={getColorClass(averageAttendance)} />
      </div>

      <div className="flex items-center gap-2 mt-4">
        <AppButton
          color="blue"
          fullWidth
          onPress={handleDownload}
          startIcon={DownloadIcon}
        >
          Download
        </AppButton>
      </div>
    </section>
  );
};
